const SectionSeperator = ({ title }: { title: React.ReactNode }) => {
  return (
    <div className="p-overview__seperator">
      <p className="p-overview__seperator__title">{title}</p>
    </div>
  );
};

export default SectionSeperator;
